import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import config from '../../config';
import IconLogo from './IconLogo';
import LogoImage from '../../assets/PrimaryLogo_Dark.png';
import logoWhite from '../../assets/PrimaryLogo_Light.png';
import css from './Logo.module.css';

const Logo = props => {
  const { className, format, ...rest } = props;
  const mobileClasses = classNames(css.logoMobile, className);

  if (format === 'desktop') {
    return <img className={className} src={LogoImage} alt={config.siteTitle} {...rest} />;
  }

  if (format === 'custom_white') {
    return <img className={className} src={logoWhite} alt={config.siteTitle} {...rest} />;

  }

  if (format === 'complete_mobile') {
    return <img className={mobileClasses} src={LogoImage} alt={config.siteTitle} {...rest} />;
  }

  return <IconLogo className={mobileClasses} {...rest} />;
};

const { oneOf, string } = PropTypes;

Logo.defaultProps = {
  className: null,
  format: 'desktop',
};

Logo.propTypes = {
  className: string,
  format: oneOf(['desktop', 'mobile', 'complete_mobile', 'custom_white']),
};

export default Logo;
